import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'cvlib';

import './CallCenterScreen.scss';
import { getTranslation } from '../../../../utils/getTranslation';
import { useEpgTransactions } from './hooks/useEpgTransactions';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import { useSearchParams } from 'react-router-dom';

const CallCenterScreen = ({ forceCallCenter, setForceCallCenter }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const groupId = searchParams.get('groupId');
  const epgLineUp = useSelector(state => state?.EpgLineUp?.data);
  const channelFromEpgLineup = epgLineUp?.find(
    channel => channel?.group_id === groupId,
  );
  const translations = useSelector(state => state.translations);
  const data = useSelector(
    state => state.Player.EpgTransactions.epgTransactions.data,
  );
  const proveedorCode =
    data?.proveedor_code ||
    data?.extendedcommon?.media?.proveedor?.codigo ||
    channelFromEpgLineup?.group?.common?.extendedcommon?.media?.proveedor
      ?.codigo;
  const { handleExitOrCancel } = useEpgTransactions();

  const title = getTranslation(
    `Transaccionales_CallCenter_TextoTitulo_${proveedorCode}`,
    translations,
  );
  const description = getTranslation(
    `Transaccionales_CallCenter_TextoParrafo1_${proveedorCode}`,
    translations,
  );
  const description2 = getTranslation(
    `Transaccionales_CallCenter_TextoParrafo2_${proveedorCode}`,
    translations,
  );
  const titleNumber = getTranslation(
    `Transaccionales_CallCenter_TextoParrafo3_${proveedorCode}`,
    translations,
  );
  const number = getTranslation(
    `Transaccionales_CallCenter_TextoTelefono_${proveedorCode}`,
    translations,
  );
  const note = getTranslation(
    `Transaccionales_CallCenter_TextoParrafo4_${proveedorCode}`,
    translations,
  );
  const note2 = getTranslation(
    `Transaccionales_CallCenter_TextoParrafo5_${proveedorCode}`,
    translations,
  );
  const cancel = getTranslation(
    `Transaccionales_CallCenter_TextoBotonPrimarioAceptar_${proveedorCode}`,
    translations,
  );
  const btnColor = getTranslation('Color_ColorPrimario', translations);

  const handleButtonClick = () => {
    forceCallCenter ? setForceCallCenter(false) : handleExitOrCancel();
  };

  return (
    <div className="callCenter_container" style={{}}>
      <p className="callCenter__title">{renderMaxLengthText(title, 28)}</p>
      <p className="callCenter__description">
        {renderMaxLengthText(description, 35)}
      </p>
      <p className="callCenter__description2">
        {renderMaxLengthText(description2, 40)}
      </p>
      <p className="callCenter__titleNumber">
        {renderMaxLengthText(titleNumber, 31)}
      </p>
      <p className="callCenter__number">{renderMaxLengthText(number, 24)}</p>
      <p className="callCenter__note">{renderMaxLengthText(note, 31)}</p>
      <p className="callCenter__note2">{renderMaxLengthText(note2, 31)}</p>

      <div className="callCenter__buttonContainer">
        <Button
          type="red"
          onClick={() => handleButtonClick()}
          className={'callCenter__cancelButton'}
          style={{
            backgroundColor: btnColor,
            minHeight: 40,
          }}
        >
          {cancel}
        </Button>
      </div>
    </div>
  );
};

export default CallCenterScreen;
